/** A smooth axolotl face that stays legible from title bar to splash. */

export interface CoreconfMarkProps {
  size?: number;
  title?: string;
}

export function CoreconfMark({
  size = 32,
  title = 'Coreconf',
}: CoreconfMarkProps): React.ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label={title}
      style={{ display: 'block' }}
    >
      {title ? <title>{title}</title> : null}
      <rect x="2" y="2" width="28" height="28" rx="9" fill="var(--gill)" />
      <g
        fill="none"
        stroke="var(--ink-inverse)"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10.2 11.3 7.4 8.9M9.3 14.7 6.1 14.1M10.2 18.1 7.5 20.4" />
        <path d="M21.8 11.3 24.6 8.9M22.7 14.7 25.9 14.1M21.8 18.1 24.5 20.4" />
        <path d="M10.6 10.1c1.3-1 3.1-1.5 5.4-1.5s4.1.5 5.4 1.5c1.2 1 1.8 2.5 1.8 4.6 0 4.4-2.7 7.1-7.2 7.1s-7.2-2.7-7.2-7.1c0-2.1.6-3.6 1.8-4.6Z" />
        <path d="M13.3 17.3c.8.8 1.7 1.2 2.7 1.2s1.9-.4 2.7-1.2" />
      </g>
      <path
        d="M13 13.8h.01M19 13.8h.01"
        stroke="var(--ink-inverse)"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
